<template>
  <div style="text-align: -webkit-center">
    <DescriptorsContainer
      :ref_component="'Competence'"
      :Title_text="$t('curricularProducts.competence.programs')"
      :Title="competenceDescriptor"
      :Descriptors="cMiddleDescriptors"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
      :Order="1"
      :VisibleOrder="false"
      :ProgramView="true"
      :rich_text_editor="false"
      :show_is_default="false"
      :show_visible="show_visible"
      @updateOrder="updateOrderCMiddleDescriptors"
      @updateState="updateVisibleCMiddleDescriptors"
      @createDescription="createCMiddleDescriptors"
      @updateDescription="updateCMiddleDescriptors"
      @createTitle="createCompetenceDescriptors"
      @updateTitle="updateCompetenceDescriptors"
      @deleteDescriptors="deleteCompetenceDescriptors"
      @deleteTitle="deleteTitle"
    >
    </DescriptorsContainer>
  </div>
</template>

<script>
export default {
  name: "CompetenceDescriptors",
  components: {
    DescriptorsContainer: () =>
      import("@/components/reusable/DescriptorsContainer"),
  },
  props: {
    egress_profile_id: {
      type: Number,
    },
    competence_id: {
      type: Number,
      required: true,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    show_visible: {
      type: Boolean,
      default: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      competenceDescriptor: [],
      cMiddleDescriptors: [],
    };
  },
  computed: {},
  methods: {
    mutateCMDescriptor(item) {
      let index = this.cMiddleDescriptors.findIndex((x) => x.id == item.id);
      if (index != -1) this.cMiddleDescriptors.splice(index, 1, item);
      else this.cMiddleDescriptors.push(item);
    },
    mutateDeleteCMDescriptor(cMDescriptor_id) {
      let index = this.cMiddleDescriptors.findIndex(
        (x) => x.id == cMDescriptor_id
      );
      if (index != -1) this.cMiddleDescriptors.splice(index, 1);
    },
    mutateCompetenceDescriptor(item) {
      let index = this.competenceDescriptor.findIndex((x) => x.id == item.id);
      if (index != -1) this.competenceDescriptor.splice(index, 1, item);
      else this.competenceDescriptor.push(item);
    },
    mutateDeleteCompetenceDescriptor(competenceDescriptor_id) {
      let index = this.competenceDescriptor.findIndex(
        (x) => x.id == competenceDescriptor_id
      );
      if (index != -1) this.competenceDescriptor.splice(index, 1);
    },
    updateOrderCMiddleDescriptors(item) {
      let order = 1;
      item.forEach((element) => {
        if (element.order != order) {
          element.order = order;
          if (
            !isNaN(element.id) &&
            this.cMiddleDescriptors.findIndex((x) => x.id == element.id) != -1
          ) {
            let payload = {
              id: element.id,
              item: {
                order: element.order,
              },
            };
            this.$restful
              .Patch(
                `/mesh/competence-middle-descriptor/${payload.id}/`,
                payload.item
              )
              .then((response) => {
                this.mutateCMDescriptor(response);
              });
          }
        }
        order += 1;
      });
    },
    createCMiddleDescriptors(text, object) {
      if (!isNaN(object.id) && this.competence_id) {
        let item = {
          competence: this.competence_id,
          descriptor: object.id,
          description: text,
          order: 1 + this.cMiddleDescriptors.length,
        };
        this.$restful
          .Post(`/mesh/competence-middle-descriptor/`, item)
          .then((response) => {
            this.mutateCMDescriptor(response);
            this.$emit("reset_competence");
          });
      }
    },
    updateCMiddleDescriptors(object, text) {
      if (!isNaN(object.id)) {
        let payload = {
          id: object.id,
          item: {
            description: text,
          },
        };
        this.$restful
          .Patch(
            `/mesh/competence-middle-descriptor/${payload.id}/`,
            payload.item
          )
          .then((response) => {
            this.mutateCMDescriptor(response);
            this.$emit("change_middle_descriptors", response);
          });
      }
    },
    updateVisibleCMiddleDescriptors(item) {
      if (this.egress_profile_id && item.descriptor) {
        // Con perfil de egreso: toggle por perfil (afecta todos los descriptors del mismo tipo)
        const payload = {
          egress_profile_id: this.egress_profile_id,
          descriptor_id: item.descriptor,
          is_visible: !item.is_visible,
        };
        this.$restful
          .Post(
            "/mesh/toggle_competence_middle_descriptor_visibility/",
            payload
          )
          .then((response) => {
            if (response.success) {
              this.cMiddleDescriptors.forEach((descriptor) => {
                if (descriptor.descriptor === item.descriptor) {
                  descriptor.is_visible = payload.is_visible;
                }
              });
              this.$emit("reset_competence_table");
            }
          })
          .catch((error) => {
            console.error("Error toggling visibility:", error);
          });
      } else if (!isNaN(item.id)) {
        // Sin perfil de egreso: PATCH directo sobre el descriptor individual
        this.$restful
          .Patch(`/mesh/competence-middle-descriptor/${item.id}/`, {
            is_visible: !item.is_visible,
          })
          .then((response) => {
            this.mutateCMDescriptor(response);
            this.$emit("change_middle_descriptors", response);
          });
      }
    },
    createCompetenceDescriptors(title) {
      if (isNaN(title.id)) {
        this.$restful
          .Post(`/mesh/competence-descriptor/`, title)
          .then((response) => {
            this.mutateCompetenceDescriptor(response);
            this.$emit("reset_competence_table");
            this.createCMiddleDescriptors("", response);
          });
      }
    },
    updateCompetenceDescriptors(title) {
      if (!isNaN(title.id)) {
        let payload = {
          id: title.id,
          item: {
            title: title.title,
            is_default: title.is_default,
          },
        };
        this.$restful
          .Patch(`/mesh/competence-descriptor/${payload.id}/`, payload.item)
          .then((response) => {
            this.mutateCompetenceDescriptor(response);
            this.$emit("reset_competence_table");
          });
      }
    },
    deleteCompetenceDescriptors(cMiddleDescriptor) {
      this.$swal({
        title: this.$t(
          "curricularProducts.competence.deleteDescriptorContentConfirm"
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
        cancelButtonText: this.$t("reusable.common.cancel"),
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(
              `/mesh/competence-middle-descriptor/${cMiddleDescriptor.id}/`
            )
            .then(() => {
              this.mutateDeleteCMDescriptor(cMiddleDescriptor.id);
              this.fetchCMiddleDescriptors();
              this.$emit("reset_competence_table");
            });
        }
      });
    },
    deleteTitle(object) {
      this.$restful
        .GetAll(`/mesh/competence-middle-descriptor/?descriptor__id=${object.id}`)
        .then((response) => {
          this.$swal({
            title: this.$t(
              "curricularProducts.competence.deleteDescriptorTitleConfirm"
            ),
            text: this.$t(
              "curricularProducts.competence.deleteDescriptorWarning"
            ),
            footer: `<ul class="w-100" style="max-height: 300px; overflow-y: auto;">
            <li>${this.$t("curricularProducts.competence.title")}: ${
              object.title
            }</li>
            ${response
              .map(
                (item) =>
                  `<li>${this.$t(
                    "curricularProducts.competence.content"
                  )}: ${this.$htmlToPlainText(item.description)}</li>`
              )
              .join("")}</ul>`,
            type: "warning",
            showCancelButton: true,
            cancelButtonText: this.$t("reusable.common.cancel"),
          }).then((result) => {
            if (result.value) {
              this.$restful
                .Delete(`/mesh/competence-descriptor/${object.id}/`)
                .then(() => {
                  this.mutateDeleteCompetenceDescriptor(object.id);
                  this.fetchCMiddleDescriptors();
                  this.$emit("reset_competence_table");
                });
            }
          });
        });
    },
    fetchCompetenceDescriptor() {
      this.$restful.GetAll(`/mesh/competence-descriptor/`).then((response) => {
        this.competenceDescriptor = response;
      });
    },
    fetchCMiddleDescriptors() {
      this.$restful
        .GetAll(
          `/mesh/competence-middle-descriptor/?competence=${this.competence_id}`
        )
        .then((response) => {
          this.cMiddleDescriptors = response;
        });
    },
  },
  mounted() {},
  created() {
    this.fetchCompetenceDescriptor();
    this.fetchCMiddleDescriptors();
  },
};
</script>

<style scoped>
</style>